import styled, { keyframes } from "styled-components";
import { responsiveMap } from "../../Grid/_utils/responsiveObserve";

const scrollHintNudge = keyframes`
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(7px);
  }
`;

/** Zone de tap large, sans aplats de couleur (contrairement aux flèches du slider vidéo). */
export const _LandingHeaderScrollHintButton = styled.button`
  position: absolute;
  left: 0;
  bottom: 64px;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 128px;
  padding: 20px;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  @media (prefers-reduced-motion: no-preference) {
    &:focus-visible {
      outline: 2px solid rgba(255, 255, 255, 0.7);
      outline-offset: 4px;
    }
  }

  @media ${responsiveMap.mobile} {
    bottom: 128px;
  }
`;

export const _LandingHeaderScrollHintIconWrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;

  @media (prefers-reduced-motion: no-preference) {
    animation: ${scrollHintNudge} 1.6s ease-in-out infinite;
  }
`;
